import { useRouter } from 'next/router'
import { FC } from 'react'

import * as SC from './styled'

export type NoConnexionProps = {
  className?: string
  text: string
}

const NoConnexion: FC<NoConnexionProps> = (props) => {
  const { className, text } = props
  const nextRouter = useRouter()

  return (
    <SC.Container className={className}>
      <SC.BackButton
        actionProps={{
          onClick: () => nextRouter.back(),
        }}
        icon="backArrow"
        variantType="button"
        variantColorScheme="whiteHoverBlack"
      />
      <SC.SadFace>{':('}</SC.SadFace>
      <SC.Text>{text}</SC.Text>
    </SC.Container>
  )
}

export default NoConnexion
